import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import {
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Lazy load QuickView - only loaded when user clicks to quick view a product
// This defers Chakra Modal/Drawer components and product-view until needed
const QuickView = loadable(() => import('../../../components/quick-view'), {ssr: false})

const ProductTileMobileQuickView = ({
    isOpen,
    onClose,
    productId,
    isProductInWishlist,
    wishlistCount,
    setProductId,
    isWishlistPage,
    wishlistProductId,
    product,
    onVariantSelect,
    onProductChange,
    setIsQuickViewOpen,
    onQuickViewClose,
    quickViewVariant,
    forceMobileLayout = false,
    placement = 'bottom',
    size = 'sm',
    motionPreset = 'slideInBottom',
    height = '85vh',
    isFullHeight = false,
    showBackButton = false,
    onBack,
    onLocalSelectionsChange
}) => {
    const shouldConstrainHeight = !isFullHeight && placement === 'bottom'
    const drawerContentHeight = shouldConstrainHeight ? height : undefined
    const drawerContentWidth = placement === 'right' ? '448px' : undefined

    return (
        <Drawer
            placement={placement}
            isOpen={isOpen}
            onClose={onClose}
            size={size}
            motionPreset={motionPreset}
            scrollBehavior="inside"
            isFullHeight={isFullHeight}
            returnFocusOnClose={false}
            closeOnOverlayClick={true}
        >
            <DrawerOverlay />
            <DrawerContent
                height={drawerContentHeight}
                maxHeight={drawerContentHeight}
                width={drawerContentWidth}
                maxWidth={drawerContentWidth}
                marginTop={0}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <DrawerBody padding="0">
                    <QuickView
                        productId={productId}
                        setIsQuickViewOpen={setIsQuickViewOpen}
                        showImageGallery={true}
                        themeVariant={quickViewVariant}
                        isFavourite={isProductInWishlist}
                        wishlistCount={wishlistCount}
                        setProductId={setProductId}
                        isWishlistPage={isWishlistPage}
                        wishlistProductId={wishlistProductId}
                        disableFocusTrap={true}
                        searchHitData={product}
                        onVariantSelect={onVariantSelect}
                        onProductChange={onProductChange}
                        onQuickViewClose={onQuickViewClose}
                        forceMobileLayout={forceMobileLayout}
                        showBackButton={showBackButton}
                        onBack={onBack}
                        onLocalSelectionsChange={onLocalSelectionsChange}
                    />
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    )
}

ProductTileMobileQuickView.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    productId: PropTypes.string,
    isProductInWishlist: PropTypes.bool,
    wishlistCount: PropTypes.number,
    setProductId: PropTypes.func,
    isWishlistPage: PropTypes.bool,
    wishlistProductId: PropTypes.string,
    product: PropTypes.object,
    onVariantSelect: PropTypes.func,
    onProductChange: PropTypes.func,
    setIsQuickViewOpen: PropTypes.func,
    onQuickViewClose: PropTypes.func,
    quickViewVariant: PropTypes.string,
    forceMobileLayout: PropTypes.bool,
    placement: PropTypes.string,
    size: PropTypes.string,
    motionPreset: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isFullHeight: PropTypes.bool,
    showBackButton: PropTypes.bool,
    onBack: PropTypes.func,
    onLocalSelectionsChange: PropTypes.func
}

export default ProductTileMobileQuickView
